import { filter } from 'rxjs/operators';

/**
 * Provide to an observable pipe to filter out emitted values that are undefined or null.
 *
 * The filter function is a type guard so the type of the returned observable will be refined to not include undefined or null.
 *
 * ```
 * o$: Observable<Foo | undefined | null> = ...
 * // The explicit type below for o2$ isn't required (it can be inferred)
 * // but it is used here to demonstrate the type refinement
 * o2$: Observable<Foo> = o$.pipe(
 *  tap((v) => {
 *    // v might be undefined or null here
 *  })
 *  filterNullAndUndefined(),
 *  map((v) => {
 *   // v will not be undefined or null here
 *  }),
 * )
 * ```
 */
export function filterNullAndUndefined<T>() {
  return filter(isNotNullOrUndefined<T>);
}

export function isNotNullOrUndefined<T>(x: T | undefined | null): x is T {
  return x !== undefined && x !== null;
}
